import qs from 'qs'
import Vue from 'vue'
import axios from 'axios'
import Hammer from 'hammerjs'
import Cookies from 'js-cookie'
window.ttvue = Vue
const CONSTANT = require('./constant')
const LAST_SEL_TAB = 'last_sel_tab'
const wxAuthConfig = require('../../config/wxAuthConfig')

export function getEnv () {
  return process.env.CDN_ENV
  // let env
  // const origin = window.location.origin
  // // 测试and灰度
  // if (
  //   RegExp('sdibeta-wecity.sparta.html5.qq.com').test(origin) ||
  //   RegExp('2020012410522702').test(window.location.pathname) ||
  //   RegExp('wuhan-test').test(window.location.pathname)
  // ) {
  //   env = 'development'
  // } else if (RegExp('wecity.qq.com').test(origin)) {
  //   env = 'production'
  // } else {
  //   env = 'local'
  // }
  // return env
}
export function getQueryStringOld (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = (window.location.hash || window.location.search).substr(1).match(reg)
  if (r != null) return unescape(r[2]); return null
}

export function getQueryString (name) {
  let urlObj = new URL(location.href)

  if (urlObj.hash && urlObj.hash.indexOf('?') !== -1) {
    let searchObj = new URLSearchParams(urlObj.hash.split('?')[1] || '')
    if (searchObj.get(name)) return searchObj.get(name)
  }

  if (urlObj.search && urlObj.searchParams.get(name)) {
    return urlObj.searchParams.get(name)
  }

  return null
}

export function isWeixin () {
  /**
   * 如果在iframe，则不走微信环境判定，否则会出现 iframe下 wx.miniProgram.getEnv 表现异常
   * 以及跳转授权时无法处理授权
   * 文档 : https://docs.qq.com/doc/DYk1UWXJMaWFlTm56
   */
  if (self !== top) {
    return false
  }
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.match(/MicroMessenger/i) == 'micromessenger'
}

export async function getBrowserEnv () {
  if (isWeixin()) {
    // 安卓企业微信这里很坑，没有注入 window.wx.miniProgram
    if (!window.wx.miniProgram) {
      return 'wx'
    }
    const getEnvPromise = () => new Promise(resolve => {
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          resolve('mini')
        }
        resolve('wx')
      })
    })
    // ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
    const wxEnv = await getEnvPromise()
    return wxEnv
  }
  return 'h5'
}

export const BASE_URL = CONSTANT.BASE_URL
export const ERROR_CODE = CONSTANT.ERROR_CODE

export function getLink ({ baseHtml = 'index.html', path, query, needAuth = true, $route } = {}) {
  if (!$route) {
    throw new Error('getLink require $route params')
  }
  const queryObj = {
    ...query
  }

  // const tab = sessionStorage.getItem(LAST_SEL_TAB)
  // if (tab) {
  //   queryObj.tab = tab
  // }

  const { navColor, frontColor, cityCode, cityName, lat, lng } = $route.query
  if (navColor && frontColor) {
    queryObj.nav_color = navColor
    queryObj.front_color = frontColor
  } else {
    queryObj.nav_color = '5391FF'
    queryObj.front_color = 'ffffff'
  }
  // 医院列表页分享参数
  if (cityCode && cityName) {
    queryObj.cityCode = cityCode
    queryObj.cityName = cityName
    queryObj.lat = lat || 0
    queryObj.lng = lng || 0
  }

  if (Vue.prototype.$browserEnv === 'mini') {
    console.log('🍓 getLink append miniuserid: ', Cookies.get('_txjk_feiyanh5_miniuserid') || '')
    queryObj.miniuserid = Cookies.get('_txjk_feiyanh5_miniuserid') || ''
  }

  return `${location.origin}${BASE_URL}${baseHtml}#/${path}?${qs.stringify(queryObj)}`
}

// 公众号页面分享支持 配置 shareDesc
export function shareToMini (title, link, imageUrl, shareDesc = '', curHeaderTab = 'global') {
  console.log('🌟 link', link, title, shareDesc, curHeaderTab)
  let defaultImgUrl = ''
  let shareImgEnv = process.env.CDN_ENV === 'production' ? 'formal' : 'pre'
  if (curHeaderTab === 'abroad') {
    defaultImgUrl = `https://static.wecity.qq.com/auto-create-image-sotre/wuhan-share-with-number-${shareImgEnv}-haiwai.png?x_cache_fresh=on&currentTime=${Date.now()}`
  } else if (curHeaderTab === 'otherArea') {
    defaultImgUrl = `https://static.wecity.qq.com/auto-create-image-sotre/wuhan-share-with-number-${shareImgEnv}-hubeishengwai.png?x_cache_fresh=on&currentTime=${Date.now()}`
  } else {
    defaultImgUrl = `https://static.wecity.qq.com/auto-create-image-sotre/wuhan-share-with-number-${shareImgEnv}-quanguo.png?x_cache_fresh=on&currentTime=${Date.now()}`
  }
  if (Vue.prototype.$browserEnv === 'mini') {
    const path = '/pages/webview/main?src=' + encodeURIComponent(link)
    const sharePath = `/pages/index/home/main?navigate_uri=${encodeURIComponent(path)}&channel=${(window._msdk && window._msdk.channel) || ''}`
    window.wx.miniProgram.postMessage({
      data: {
        type: 'share',
        shareInfo: {
          title,
          path: sharePath,
          // 传入default字段使用小程序自带的截图功能
          // imageUrl: imageUrl || 'https://static.wecity.qq.com/wuhan/ban2-3b7b1f0429fc159e2e8594f0cf478336.png'
          imageUrl: imageUrl === 'default' ? '' : (imageUrl || defaultImgUrl)
        }
      }
    })
  } else if (Vue.prototype.$browserEnv === 'wx') {
    window.wx.ready(function () { // 需在用户可能点击分享按钮前就先调用
      window.wx.onMenuShareAppMessage({
        link: link,
        title: title,
        desc: shareDesc || location.href,
        // imgUrl: imageUrl || 'https://static.wecity.qq.com/wuhan-static/wuhan-h5-share-pic.png',
        imgUrl: imageUrl || defaultImgUrl,
        success: () => {
          console.log('分享成功')
        }
      })
      window.wx.onMenuShareTimeline({
        link: link,
        title: title,
        // imgUrl: imageUrl || 'https://static.wecity.qq.com/wuhan-static/wuhan-h5-share-pic.png',
        imgUrl: imageUrl || defaultImgUrl,
        success: () => {
          console.log('分享成功')
        }
      })
    })
  }
}

let jsSdkSignMap = {}
const jsApiList = ['getLocation', 'openLocation', 'onMenuShareAppMessage', 'onMenuShareTimeline']
export async function getJssdkRight () {
  if (!isWeixin()) {
    return Promise.resolve(false)
  } else {
    const params = {
      appId: wxAuthConfig.appidGetter(),
      componentId: wxAuthConfig.componentIdGetter(),
      url: location.href.split('#')[0]
    }
    const cacheKey = JSON.stringify(params)
    if (jsSdkSignMap[cacheKey]) {
      return jsSdkSignMap[cacheKey]
    }
    // Comment: 过滤localhost 和 调试域名
    if (location.hostname === 'localhost' || location.hostname === 'sdibeta-wecity-test.sparta.html5.qq.com') { return }
    // console.log(await axios.get(`${CONSTANT.MISC_URL}/api/wechat/getJssdkSign`, { params }))
    const { data: { code, data } } = await axios.get(`${CONSTANT.MISC_URL}/api/wechat/getJssdkSign`, { params })
    if (code === 0) {
      Object.assign(data, {
        beta: true,
        debug: false,
        jsApiList
      })
      window.wx.config(data)
      const promise = new Promise((resolve, reject) => {
        window.wx.ready(resolve)
        window.wx.error(reject)
        resolve(true)
      })
      jsSdkSignMap[cacheKey] = promise
      return Promise.resolve(true)
    } else {
      throw new Error(`getJssdkSign code: ${code}`)
    }
  }
}

export function isSubscribe () {
  return /minitype=th/.test(window.location.href)
}

/**
 * 检查当前是否是腾讯健康小程序
 */
export function isInTH () {
  return isWeixin() && isSubscribe()
}

/* 向url追加query串 */
export function appendQuery (url, queryObj) {
  let urlObj = new URL(url)

  if (urlObj.hash) {
    let hashData = urlObj.hash.split('?')
    let searchObj = new URLSearchParams(hashData[1] || '')
    for (let k in queryObj) {
      searchObj.set(k, queryObj[k])
    }
    urlObj.hash = `${hashData[0]}?${searchObj.toString()}`
  }

  if (urlObj.search) {
    for (let k in queryObj) {
      if (urlObj.searchParams.get(k)) {
        urlObj.searchParams.set(k, queryObj[k])
      }
    }
  }

  return urlObj.href
}
/**监听长按事件 */
export function listenLongPress(element, options, cb) {
let square = document.querySelector(element);
let manager = new Hammer.Manager(square);
var Press = new Hammer.Press(options);
manager.add(Press);
manager.on('press', cb);
}

export function getDay(num, str) {
  var today = new Date();
  var nowTime = today.getTime();
  var ms = 24*3600*1000*num;
  today.setTime(parseInt(nowTime + ms));
  var oYear = today.getFullYear();
  var oMoth = (today.getMonth() + 1).toString();
  if (oMoth.length <= 1) oMoth = '0' + oMoth;
  var oDay = today.getDate().toString();
  if (oDay.length <= 1) oDay = '0' + oDay;
  return oYear + str + oMoth + str + oDay;
}

function isAndroid() {
  return /android/i.test(navigator.userAgent)
}

export function goToLink(linkObj, $route, $router, opts = {}) {
  const { isYidianH5 } = opts
  const curQuery = $route.query
  switch (linkObj.type) {
    case 1:
      linkObj.url = appendQuery(linkObj.url, curQuery)
      const { minitype } = curQuery
      console.log('啊啊啊啊微信浏览器好烦啊', isYidianH5, minitype, isAndroid())
      console.log(window.location.href)
      if (isYidianH5 && minitype === 'th' && isAndroid()) {
        const url = `/pages/yidian/webview/main?src=${encodeURIComponent(linkObj.url)}`
        console.log('🐭 跳转到医典咨询页', url)
        wx.miniProgram.navigateTo({ url })
        break
      }
      location.href = linkObj.url
      break
    case 2:
      wx.miniProgram.navigateTo({
        appId: linkObj.appId,
        url: linkObj.url,
      })
      break
    case 3:
      wx.miniProgram.navigateTo({ url: linkObj.url })
      break


    // case 2:
    //   $router.push({ path: linkObj.url, query: curQuery })
    //   break
    // case 3:
    //   wx.miniProgram.navigateTo({ url: linkObj.url })
    //   break
    // case 4:
    //   let url = location.origin + linkObj.url
    //   url = appendQuery(url, curQuery)
    //   location.href = url
    //   break
    default:
      console.log('目标参数异常，跳转失败')
      break
  }
}
